import React from 'react';
import { ForgotPassword } from '../../components/Forms/ForgotPassword';
import { Home } from './Home';

export const ForgotPasswordPage = () => <Home><ForgotPassword /></Home>;

